import { useTranslation } from "react-i18next";

const valueItems = [
  { key: "value.item1", icon: "ri-refresh-line" },
  { key: "value.item2", icon: "ri-shield-check-line" },
  { key: "value.item3", icon: "ri-scales-line" },
  { key: "value.item4", icon: "ri-eye-off-line" },
  { key: "value.item5", icon: "ri-group-line" },
];

export default function ValueProposition() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100/50 py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            {t("value.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {valueItems.map((item, idx) => (
            <div
              key={item.key}
              className="flex gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-200"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {t(`${item.key}.title`)}
                </h4>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {t(`${item.key}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}